import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547d8c76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box ws_mb20" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-footer" }, null, -1))

import { ref, computed, watch } from 'vue'
import { CODE_ENUM, SUFFIX, PAGE_SIZES } from '@/common'
import { queryFirmwarebatchUpgradeDetail } from '@/api'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'batch-update-no-list',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const formRef = ref()

const statusOps = [
  {
    label: '成功',
    value: 'succ',
  },
  {
    label: '失败',
    value: 'fail',
  },
  {
    label: '升级中',
    value: 'receive',
  },
  {
    label: '无响应',
    value: 'run_timeout',
  },
  {
    label: '下发失败',
    value: 'run_fail',
  },
]

const textMap: any = {
  succ: '成功',
  fail: '失败',
  receive: '升级中',
  run_timeout: '无响应',
  run_fail: '下发失败',
}

const statusMap: any = {
  succ: 'primary',
  fail: 'warning',
  receive: 'primary',
  run_timeout: 'info',
  run_fail: 'danger',
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      fetchList()
    }
  }
)

const formInline = ref({
  deviceName: '',
  deviceSN: '',
  upgradeResult: '',
})
const loading = ref(false)

const tableData = ref([])
const tableLoading = ref(false)

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const search = () => {
  pageParams.value.curPage = 1
  fetchList()
}

const reset = () => {
  formRef.value?.resetFields?.()
  pageParams.value.curPage = 1
  fetchList()
}

const fetchList = async () => {
  tableLoading.value = true
  const { deviceName, deviceSN, upgradeResult } = formInline.value
  const res: any = await queryFirmwarebatchUpgradeDetail({
    upgradeId: props.data.id,
    ...pageParams.value,
    deviceName,
    deviceSN,
    upgradeResult,
  })
  tableLoading.value = false

  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  tableData.value = []
  total.value = 0
}

const col = [
  {
    label: '设备名称',
    prop: 'deviceName',
  },
  {
    label: '设备SN',
    prop: 'deviceSn',
  },
  {
    label: '芯片类型',
    prop: 'chipType',
  },
  {
    label: '旧版本',
    prop: 'versionOld',
  },
  {
    label: '升级版本',
    prop: 'versionNew',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "升级历史详情",
    width: "1340",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        inline: true,
        model: formInline.value,
        "label-position": "left",
        "label-width": 82
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "设备名称",
            prop: "deviceName",
            class: "ws_mr4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceName) = $event)),
                style: {"width":"280px"},
                placeholder: "请输入设备名称",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSN",
            class: "ws_mr4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceSN,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceSN) = $event)),
                style: {"width":"280px"},
                placeholder: "请输入设备SN",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "升级结果",
            prop: "upgradeResult",
            class: "ws_mr20"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.upgradeResult,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.upgradeResult) = $event)),
                placeholder: "请选择",
                clearable: "",
                style: {"width":"280px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查询 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                plain: "",
                onClick: reset
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重置 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_table, {
          data: tableData.value,
          class: "ws_common_table"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
              return _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": "",
                key: index,
                prop: item.prop,
                label: item.label
              }, null, 8, ["prop", "label"])
            }), 64)),
            _createVNode(_component_el_table_column, {
              width: 160,
              label: "升级结果"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: statusMap[scope.row.upgradeResult]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(textMap[scope.row.upgradeResult]), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "升级时间" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50 ws_mb36",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})